import { Col, Row } from 'antd';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router';

import { setUsersFilter } from '../../app/redux/admin';
import routes from '../../app/routes';
import { useMountEffect } from '../../common/utils/hookUtils';
import { cssVariables } from '../../styles/cssVariables';
import { pxToNumber } from '../../utils/cssUtils';
import AdminConsoleTitle from './components/AdminConsoleTitle';
import AdminUserManagementMenu from './components/AdminUserManagementMenu';
import AdminConsoleTemplate from './layout/AdminConsoleTemplate';
import AdminAddUser, { AdminAddUserSteps } from './userManagement/AdminAddUser';
import AdminUserDetail from './userManagement/AdminUserDetail';
import AdminUserList from './userManagement/AdminUserList';

export default function AdminUserManagementPage() {
  const headerRightRef = useRef();
  const dispatch = useDispatch();
  useMountEffect(() => () => dispatch(setUsersFilter({})));

  return (
    <AdminConsoleTemplate
      title={
        <>
          <AdminConsoleTitle
            titleId="admin.userManagement.title"
            icon="users"
          />
          <div ref={headerRightRef} />
        </>
      }
    >
      <Row align="top" gutter={pxToNumber(cssVariables.spaceNorm2)}>
        <Col>
          <div className="spaces-vert-md">
            <AdminUserManagementMenu />
            <Switch>
              <Route path={routes.admin.addUser}>
                <AdminAddUserSteps />
              </Route>
            </Switch>
          </div>
        </Col>
        <Col className="Flex1">
          <Switch>
            <Route path={routes.admin.userManagement} exact>
              <AdminUserList headerRightRef={headerRightRef} />
            </Route>
            <Route path={routes.admin.addUser}>
              <AdminAddUser headerRightRef={headerRightRef} />
            </Route>
            <Route path={routes.admin.userDetail}>
              {({ match }) =>
                match.params?.userId && (
                  <AdminUserDetail
                    userId={match.params.userId}
                    headerRightRef={headerRightRef}
                  />
                )
              }
            </Route>
          </Switch>
        </Col>
      </Row>
    </AdminConsoleTemplate>
  );
}
